import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ErrorComponent } from '@common/ui-sales-components';
import { StepCompletionNavigationGuard } from '@shared/data-access-navigation';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/products',
    pathMatch: 'full',
  },
  // Redirect '.html' extension so the page can be loaded in Magnolia's editor:
  {
    path: '.html',
    redirectTo: '/products',
    pathMatch: 'full',
  },
  {
    // TODO: add a guard
    path: 'quote',
    loadChildren: () =>
      import('@common/feature-quote').then(
        (module) => module.CommonFeatureQuoteModule
      ),
    canActivate: [StepCompletionNavigationGuard],
  },
  // Redirect '.html' extension so the page can be loaded in Magnolia's editor:
  {
    path: 'quote.html',
    redirectTo: '/quote',
    pathMatch: 'full',
  },
  {
    path: 'products',
    loadChildren: () =>
      import('@ao/feature-appliance-details').then(
        (module) => module.AoFeatureApplianceDetailsModule
      ),
    canActivate: [StepCompletionNavigationGuard],
  },
  // Redirect '.html' extension so the page can be loaded in Magnolia's editor:
  {
    path: 'products.html',
    redirectTo: '/products',
    pathMatch: 'full',
  },
  {
    path: 'checkout',
    children: [
      {
        path: '',
        loadChildren: () =>
          import('@sales/feature-checkout-landing').then(
            (m) => m.SalesFeatureCheckoutLandingModule
          ),
        canActivate: [StepCompletionNavigationGuard],
      },
      {
        path: 'personal-details',
        loadChildren: () =>
          import('@common/feature-checkout-personal-details').then(
            (m) => m.CommonFeatureCheckoutPersonalDetailsModule
          ),
        canActivate: [StepCompletionNavigationGuard],
      },
      {
        path: 'logged-in',
        loadChildren: () =>
          import('@sales/feature-checkout-logged-in-user').then(
            (m) => m.SalesFeatureCheckoutLoggedInUserModule
          ),
        canActivate: [StepCompletionNavigationGuard],
      },
      {
        path: 'direct-debit-payment',
        loadChildren: () =>
          import('@common/feature-checkout-direct-debit').then(
            (m) => m.CommonFeatureCheckoutDirectDebitModule
          ),
        canActivate: [StepCompletionNavigationGuard],
      },
      {
        path: 'order-confirmation',
        loadChildren: () =>
          import('@common/feature-order-confirmation').then(
            (m) => m.CommonFeatureOrderConfirmationModule
          ),
        canActivate: [StepCompletionNavigationGuard],
      },
      {
        path: 'card-payment',
        loadChildren: () =>
          import('@common/feature-checkout-card-payment').then(
            (m) => m.CommonFeatureCheckoutCardPaymentModule
          ),
        canActivate: [StepCompletionNavigationGuard],
      },
      {
        path: 'select-payment',
        loadChildren: () =>
          import('@common/feature-checkout-select-payment').then(
            (m) => m.CommonFeatureCheckoutSelectPaymentModule
          ),
        canActivate: [StepCompletionNavigationGuard],
      },
      {
        path: 'payment-details-summary',
        loadChildren: () =>
          import('@common/feature-checkout-direct-debit-confirmation').then(
            (m) => m.CommonFeatureCheckoutDirectDebitConfirmationModule
          ),
      },
    ],
  },
  { path: 'error', data: { title: 'Error' }, component: ErrorComponent },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      paramsInheritanceStrategy: 'always',
      relativeLinkResolution: 'corrected',
    }),
  ],
  exports: [RouterModule],
})
export class AoFeatureShellRoutingModule {} // Main routes for application
